var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4175 1.17C17.2583 0.82097 17.002 0.525091 16.6793 0.317643C16.3566 0.110195 15.9811 -6.84764e-05 15.5975 3.19045e-08H1.99747C1.61312 0.0004862 1.23704 0.111712 0.914258 0.320367C0.591471 0.529022 0.335644 0.826267 0.177393 1.17653C0.0191413 1.52679 -0.0348315 1.91524 0.0219337 2.29538C0.0786989 2.67552 0.243797 3.03125 0.497471 3.32L5.79747 9.38V19C5.79713 19.1699 5.84011 19.3372 5.92234 19.4859C6.00458 19.6346 6.12336 19.7599 6.26747 19.85C6.42661 19.9486 6.61025 20.0006 6.79747 20C6.95401 19.9991 7.10815 19.9614 7.24747 19.89L11.2475 17.89C11.4124 17.8069 11.5511 17.6798 11.6481 17.5227C11.7452 17.3656 11.7969 17.1847 11.7975 17V9.38L17.0975 3.32C17.3524 3.03063 17.5183 2.67373 17.5751 2.29227C17.6318 1.91081 17.5771 1.52107 17.4175 1.17Z",
    fill: "url(#paint0_linear_3447_60294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 9C12.13 9 10 11.13 10 13.75C10 14.64 10.25 15.48 10.69 16.2C11.51 17.58 13.02 18.5 14.75 18.5C16.48 18.5 17.99 17.57 18.81 16.2C19.25 15.49 19.5 14.64 19.5 13.75C19.5 11.13 17.38 9 14.75 9ZM16.55 15.52C16.4 15.67 16.21 15.74 16.02 15.74C15.83 15.74 15.64 15.67 15.49 15.52L14.77 14.8L14.02 15.55C13.87 15.7 13.68 15.77 13.49 15.77C13.3 15.77 13.11 15.7 12.96 15.55C12.67 15.26 12.67 14.78 12.96 14.49L13.71 13.74L12.99 13.01C12.7 12.72 12.7 12.24 12.99 11.95C13.28 11.66 13.76 11.66 14.05 11.95L14.77 12.67L15.47 11.97C15.76 11.68 16.24 11.68 16.53 11.97C16.82 12.26 16.82 12.74 16.53 13.03L15.83 13.73L16.55 14.46C16.85 14.75 16.85 15.23 16.55 15.52Z",
    fill: "#CurrentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3447_60294",
    x1: 8.79842,
    y1: 0,
    x2: 8.79842,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClear);
export default __webpack_public_path__ + "static/media/Filter-Clear.a389eb845332e9f6bf7c4ec8b3c679e1.svg";
export { ForwardRef as ReactComponent };